import type { ReactElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface AuthLinkProps {
  to: string;
  children: ReactNode;
}

function AuthLink({ to, children }: AuthLinkProps): ReactElement {
  return (
    <Link
      to={to}
      className="vtwo:self-center vtwo:rounded vtwo:p-2.5 vtwo:text-xs vtwo:leading-[normal] vtwo:text-auth-link vtwo:underline vtwo:outline-none vtwo:hover:text-auth-muted vtwo:focus-visible:ring-2 vtwo:focus-visible:ring-auth-focus"
    >
      {children}
    </Link>
  );
}

export default AuthLink;
